import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  Card,
  Offcanvas,
} from "react-bootstrap";
import Jello from "react-reveal/Jello";
import { Formik, Form, Field } from "formik";
import { useHistory } from "react-router-dom";
import Zoom from "react-reveal/Zoom";
import VerificaToken from "../../components/VerificaToken";

function Prenotazioni() {
  const { user, setUser } = VerificaToken();
  let history = useHistory();

  const [prenotazioni, setPrenotazioni] = useState([]);
  const [parcheggi, setParcheggi] = useState([]);
  const [destinazione, setDestinazione] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const [valore, setValore] = useState(0);

  useEffect(() => {
    axios
      .get(
        `https://website-8bit-motors.herokuapp.com/prenotazioni/ListaPrenotazioni/${user.id}`
      )
      .then((response) => {
        setPrenotazioni(response.data);
        axios
          .get(
            "https://website-8bit-motors.herokuapp.com/parcheggi/ottieniParcheggi"
          )
          .then((res) => {
            setParcheggi(res.data);
          });
      });
  }, []);

  const changeValue2 = () => {
    document.getElementById("destinazione").value = "";
    document.getElementById("destinazione_personalizzata").value = "";
    const errorePer2 = document.getElementById("destinazione_personalizzata");
    const errore2 = document.getElementById("destinazione");
    if (errore2.hasAttribute("required")) {
      errore2.attributes.removeNamedItem("required");
      const required = document.createAttribute("required");
      errorePer2.attributes.setNamedItem(required);
    } else {
      errorePer2.attributes.removeNamedItem("required");
      const required = document.createAttribute("required");
      errore2.attributes.setNamedItem(required);
    }
  };

  const ritira = (id) => {
    axios
      .put(
        `https://website-8bit-motors.herokuapp.com/prenotazioni/ritira/${id}`
      )
      .then(() => {
        axios
          .put(
            `https://website-8bit-motors.herokuapp.com/incarichi/ritira/${id}`
          )
          .then(() => {
            history.go(0);
          });
      });
  };
  const restituisci = (id, modello) => {
    axios
      .put(
        `https://website-8bit-motors.herokuapp.com/prenotazioni/restituisci/${id}`
      )
      .then(() => {
        axios
          .put(
            `https://website-8bit-motors.herokuapp.com/incarichi/restituisci/${id}`
          )
          .then(() => {
            axios
              .post(
                `https://website-8bit-motors.herokuapp.com/veicoli/${modello}/confermaRestituzione`
              )
              .then(() => {
                history.go(0);
              });
          });
      });
  };
  const elimina = (id, modello) => {
    axios
      .delete(
        `https://website-8bit-motors.herokuapp.com/prenotazioni/elimina/${id}`
      )
      .then(() => {
        axios
          .delete(
            `https://website-8bit-motors.herokuapp.com/incarichi/elimina/${id}`
          )
          .then(() => {
            axios
              .post(
                `https://website-8bit-motors.herokuapp.com/veicoli/${modello}/confermaRestituzione`
              )
              .then(() => {
                history.go(0);
              });
          });
      });
  };

  const onSubmit = (data) => {
    axios
      .post(
        "https://website-8bit-motors.herokuapp.com/prenotazioni/modificaDestinazione",
        data
      )
      .then(() => {
        history.go(0);
      });
  };

  return (
    <Container fluid className="text-center">
      <Jello>
        {/* SEZIONE BANNER */}
        <Container
          fluid
          className="head-banner text-white text-center"
          id="banner_accesso"
        >
          <Row>
            <Col>
              <h1>
                <strong>8-Bit Motors</strong>
              </h1>
            </Col>
          </Row>
        </Container>
      </Jello>

      <h2 className="mt-2 mb-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-bag-plus"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M8 7.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0v-1.5H6a.5.5 0 0 1 0-1h1.5V8a.5.5 0 0 1 .5-.5z"
          />
          <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z" />
        </svg>
        Prenotazioni
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-bag-plus"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M8 7.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0v-1.5H6a.5.5 0 0 1 0-1h1.5V8a.5.5 0 0 1 .5-.5z"
          />
          <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z" />
        </svg>
      </h2>

      <Zoom>
        <Container>
          <Row>
            {prenotazioni.map((value, key) => {
              return (
                <>
                  <Col className="col-lg-4">
                    <Card key={key} className="mt-2" style={{ width: "18rem" }}>
                      <Card.Img
                        variant="top"
                        src={`https://website-8bit-motors.herokuapp.com/static/${value.modello}.jpg`}
                      />
                      <Card.Body>
                        <Card.Title>{value.modello}</Card.Title>
                        <Card.Text>
                          <h5>Rilasciato:</h5>
                          <p>{value.rilasciato}</p>
                          <h5>Consegnato:</h5>
                          <p>{value.consegnato}</p>
                          <h5>Restituito:</h5>
                          <p>{value.restituito}</p>
                        </Card.Text>
                        {value.consegnato === "si" ? (
                          <>
                            {value.rilasciato ===
                            "si" /* && value.restituito === "no" */ ? (
                              <>
                                <Col>
                                  {" "}
                                  <Button
                                    className="mt-2"
                                    variant="dark"
                                    id="ritiro"
                                    disabled
                                  >
                                    Ritirato
                                  </Button>{" "}
                                </Col>

                                {value.restituito ===
                                "si" /* value.rilasciato === "si" */ ? (
                                  <>
                                    <Col>
                                      {" "}
                                      <Button
                                        className="mt-2"
                                        variant="success"
                                        id="restituito"
                                        disabled
                                      >
                                        Restituito
                                      </Button>{" "}
                                    </Col>
                                    <Col>
                                      {" "}
                                      <Button
                                        className="mt-2"
                                        variant="danger"
                                        id="ritarda"
                                        disabled
                                      >
                                        Ritardo Rilascio
                                      </Button>{" "}
                                    </Col>
                                  </>
                                ) : (
                                  <>
                                    <Col>
                                      {" "}
                                      <Button
                                        className="mt-2"
                                        variant="success"
                                        id="restituito"
                                        onClick={() => {
                                          restituisci(value.id, value.modello);
                                        }}
                                      >
                                        Restituito
                                      </Button>{" "}
                                    </Col>
                                    <Col>
                                      {" "}
                                      <Button
                                        className="mt-2"
                                        variant="danger"
                                        onClick={() => {
                                          history.push(
                                            `/prenotazioni/Ritardo/${value.id}`
                                          );
                                        }}
                                        id="ritarda"
                                      >
                                        Segnala Ritardo
                                      </Button>{" "}
                                    </Col>
                                    <Col>
                                      {" "}
                                      <Button
                                        className="mt-2"
                                        onClick={() => {
                                          setValore(key);
                                          setShowModal(true);
                                        }}
                                      >
                                        Modifica Prenotazione
                                      </Button>{" "}
                                    </Col>
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                <Col>
                                  {" "}
                                  <Button
                                    className="mt-2"
                                    variant="dark"
                                    id="ritiro"
                                    onClick={() => {
                                      ritira(value.id);
                                    }}
                                  >
                                    Ritirato
                                  </Button>{" "}
                                </Col>
                                <Col>
                                  {" "}
                                  <Button
                                    className="mt-2"
                                    variant="success"
                                    id="restituito"
                                    disabled
                                  >
                                    Restituito
                                  </Button>{" "}
                                </Col>
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <Col>
                              {" "}
                              <Button
                                className="mt-2"
                                variant="dark"
                                id="ritiro"
                                disabled
                              >
                                Ritirato
                              </Button>{" "}
                            </Col>
                            <Col>
                              {" "}
                              <Button
                                className="mt-2"
                                variant="success"
                                id="restituito"
                                disabled
                              >
                                Restituito
                              </Button>{" "}
                            </Col>
                            <Col>
                              {" "}
                              <Button
                                className="mt-2"
                                variant="danger"
                                id="annulla"
                                onClick={() => {
                                  elimina(value.id, value.modello);
                                }}
                              >
                                Annulla Prenotazione
                              </Button>
                            </Col>
                          </>
                        )}

                        <Button
                          variant="info"
                          className="mt-2"
                          onClick={() => {
                            setValore(key);
                            setShow(true);
                          }}
                        >
                          Maggiori Informazioni
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Offcanvas show={show} onHide={handleClose}>
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title>Prenotazione Veicolo</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <h2>Info Prenotazione</h2>
                      <br />
                      <h3>Data Noleggio Iniziale:</h3>
                      <p>{prenotazioni[valore].data_noleggio_iniziale}</p>
                      <h3>Orario Noleggio Iniziale:</h3>
                      <p>{prenotazioni[valore].orario_noleggio_iniziale}</p>
                      <h3>Data Noleggio Finale:</h3>
                      <p>{prenotazioni[valore].data_noleggio_finale}</p>
                      <h3>Orario Noleggio Finale</h3>
                      <p>{prenotazioni[valore].orario_noleggio_finale}</p>
                      <h3>Luogo di Ritiro:</h3>
                      <p>{prenotazioni[valore].luogo_rilascio_ritiro}</p>
                      <h3>Modello:</h3>
                      <p>{prenotazioni[valore].modello}</p>
                      <h3>Presenza Autista:</h3>
                      <p>{prenotazioni[valore].presenza_autista}</p>
                      <h3>Destinazione:</h3>
                      <p>{prenotazioni[valore].destinazione}</p>
                      <h3>Costo Prenotazione:</h3>
                      <p>€ {prenotazioni[valore].costo_prenotazione}</p>
                      <h3>Motivazione Ritardo:</h3>
                      <p>{prenotazioni[valore].motivazione_ritardo}</p>
                    </Offcanvas.Body>
                  </Offcanvas>

                  <Modal show={showModal} onHide={handleCloseModal}>
                    <Modal.Header closeButton>
                      <Modal.Title>
                        Modifica Prenotazione {prenotazioni[valore].id}
                      </Modal.Title>
                    </Modal.Header>
                    <Formik
                      onSubmit={onSubmit}
                      initialValues={{
                        idPrenotazioneForm: prenotazioni[valore].id,
                      }}
                    >
                      <Form>
                        <Modal.Body>
                          <label className="form_registrazione">
                            Id Prenotazione:{" "}
                          </label>
                          <Field
                            value={prenotazioni[valore].id}
                            className="mt-4 mb-4 form-control input_registrazione"
                            name="idPrenotazioneForm"
                          ></Field>

                          <Zoom left opposite collapse when={!destinazione}>
                            <label className="form_registrazione">
                              Destinazione (o luogo di restituzione):{" "}
                            </label>
                            <Field
                              as="select"
                              className="mt-4 mb-4 form-control input_registrazione"
                              id="destinazione"
                              name="destinazione"
                              required
                            >
                              <option value="" name="destinazione">
                                {" "}
                                ...{" "}
                              </option>
                              {parcheggi.map((value, key) => {
                                return (
                                  <option
                                    className="mb-4"
                                    key={key}
                                    value={value.luogo}
                                    name="destinazione"
                                  >
                                    {" "}
                                    {value.luogo}{" "}
                                  </option>
                                );
                              })}
                              ;
                            </Field>
                          </Zoom>

                          <br />

                          <Button
                            className="mt-4 mb-4"
                            variant="warning"
                            onClick={() => {
                              setDestinazione(!destinazione);
                              changeValue2();
                            }}
                          >
                            {destinazione
                              ? "Scegli Tra i Nostri Parcheggi"
                              : "Imposta Una Destinazione Personalizzata"}{" "}
                          </Button>
                          <Zoom
                            left
                            opposite
                            cascade
                            collapse
                            when={destinazione}
                          >
                            <input
                              className="mt-2 form-control input_registrazione"
                              id="destinazione_personalizzata"
                              type="text"
                              name="destinazione"
                              placeholder="Es. Via dante..."
                            />
                          </Zoom>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={handleCloseModal}
                          >
                            Annulla
                          </Button>
                          <Button
                            variant="success"
                            type="submit"
                            onClick={handleCloseModal}
                          >
                            Conferma
                          </Button>
                        </Modal.Footer>
                      </Form>
                    </Formik>
                  </Modal>
                </>
              );
            })}
          </Row>
        </Container>
      </Zoom>

      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </Container>
  );
}

export default Prenotazioni;
